// **React Imports
import { memo, useMemo } from 'react'

// ** Third Party Imports
import ReactECharts from 'echarts-for-react'

const RadarChart = ({
  indicators,
  values,
  max = 10,
  name,
  showFullLengthTitle = false
}) => {
  // variables
  const options = useMemo(() => {
    return {
      tooltip: {},
      radar: {
        indicator: indicators.map((label) => ({
          name: showFullLengthTitle ? label : label.replace(/ /g, '\n'),
          max
        })),
        radius: '70%'
      },
      series: [
        {
          type: 'radar',
          name: name,
          silent: true,
          data: [
            {
              value: values,
              areaStyle: {
                color: 'rgba(0, 123, 255, 0.2)'
              },
              lineStyle: {
                color: '#007bff'
              }
            }
          ]
        }
      ]
    }
  }, [indicators, values, max, name, showFullLengthTitle])

  return (
    <ReactECharts
      option={options}
      style={{
        height: '100%',
        width: '100%'
      }}
    />
  )
}

export default memo(RadarChart)
